import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import EmbedSchedulePage from './EmbedSchedulePage';
import { ArrowLeft } from 'lucide-react';

/**
 * On-site (non-iframe) coaching booking page.
 * URL: /coaching/<slug>
 * Wraps the same EmbedSchedulePage in DCA's Layout so it appears with the
 * full DCA header/footer when accessed directly from dcaenterprisesinc.com.
 */
export default function BookWithBrandPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  return (
    <Layout title="Book a Coaching Session" description="Book a coaching session with David C. Ashley.">
      <div className="bg-[#FAFAFA] min-h-screen">
        <div className="container-custom pt-6">
          <button
            onClick={() => navigate('/coaching')}
            className="text-sm font-semibold text-[#475569] hover:text-[#1D4ED8] inline-flex items-center gap-1"
            aria-label="Back to all coaching brands"
            data-testid="back-to-hub"
          >
            <ArrowLeft size={14} aria-hidden="true" /> Back to All Coaching Brands
          </button>
        </div>
        <EmbedSchedulePage brandSlug={slug} />
      </div>
    </Layout>
  );
}
